<template>
  <div class="summary-container mt-2">
    <h4 class="title-summary">
      Summary
    </h4>
    <hr class="hr-custom">
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div class="font-14 text-placeholder">
        Amount
      </div>
      <strong v-if="amountValidate">
        {{ localStringFormat(amount) }} USD
      </strong>
      <strong v-else>
        --
      </strong>
    </div>

    <div
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div class="font-14 text-placeholder">
        Payment method
      </div>
      <div
        v-if="amount"
        class="d-flex align-items-center"
      >
        <img
          :src="getBrandIcon(paymentMethod.type)"
          alt="payment"
          style="margin-right: 6px;width: 26px"
        >
        <strong class="text-capitalize">{{ convertNamePayment(paymentMethod.type) }}</strong>
      </div>
      <strong v-else> -- </strong>
    </div>

    <div class="d-flex align-items-center justify-content-between mb-1">
      <div class="font-14 text-placeholder">
        Currency
      </div>
      <div v-if="amount">
        <!-- <img
          :src="paymentMethod.icon"
          width="18px"
          alt="coin"
          style="margin-right: 6px"
        > -->
        <strong>{{ paymentMethod.value }}</strong>
      </div>
      <strong v-else>
        --
      </strong>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div class="font-14 text-placeholder">
        Account location
      </div>
      <div v-if="amount">
        <img
          :src="paymentMethod.icon"
          width="18px"
          alt="coin"
          style="margin-right: 6px"
        >
        {{ paymentMethod.name }}
      </div>
      <strong v-else>
        --
      </strong>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div class="font-14 text-placeholder">
        Service charge
        <small
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${percentFeeTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amountValidate"
          class="d-flex align-items-center"
        >
          <strong class="text-primary">{{ serviceCharge }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="taxRate > 0"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div class="font-14 text-placeholder">
        Tax
        <small
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${percentTaxTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amountValidate"
          class="d-flex align-items-center"
        >
          <strong class="text-primary">{{ tax }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="amountTip > 0"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        class="font-14 text-placeholder"
      >
        Tip
        <small
          v-if="amount"
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${percentTipTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amount"
          class="d-flex align-items-center"
        >
          <strong
            class="text-primary"
          >{{ amountTipTxt }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <!-- <div class="d-flex align-items-center justify-content-between">
      <div class="font-14 text-placeholder">
        Transfer network
      </div>
      <div class="transfer">
        <div
          v-if="amountValidate"
          class="d-flex align-items-center"
        >
          <strong class="theme-text-primary">{{ transfer.value }}</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div> -->
    <hr class="hr-custom">
    <div class="d-flex align-items-center justify-content-between pb-3">
      <div class="font-24 text-placeholder">
        Total Amount
      </div>
      <strong
        v-if="amountValidate"
        class="font-24"
      >
        {{ totalAmount }} USD
      </strong>
      <strong v-else>
        --
      </strong>
    </div>
  </div>
</template>

<script>
import paymentMixin from '@/mixins/paymentMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import numberFormatMixin from '@/mixins/numberFormatMixin'

// plugins
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {

  mixins: [paymentMixin, generalConfigsMixin, numberFormatMixin],

  props: {
    amount: {
      type: Number,
      required: true,
    },
    paymentMethod: {
      type: Object,
      required: true,
    },
    transfer: {
      type: Object,
      required: true,
    },
    amountTip: {
      type: Number,
      required: false,
      default: 0,
    },
    currentTip: {
      type: Number,
      required: false,
      default: 0,
    },
    showTipsInput: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapGettersAuth(['user']),

    isInTrial() {
      return this.user?.isInTrial
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.airWallex || 0
    },

    percentFeeTxt() {
      return `${(this.percentFee * 100).toFixed(2)}%`
    },

    percentTaxTxt() {
      return `${(this.taxRate * 100).toFixed(2)}%`
    },

    tax() {
      // return parseFloat(this.truncDigits(this.taxRate * this.amount)).toLocaleString('en-US')
      return this.amountFormat(this.taxRate * this.amount).toLocaleString('en-US')
    },

    totalAmount() {
      const fee = this.amountFormat(this.percentFee * this.amount)
      const tax = this.amountFormat(this.taxRate * this.amount)
      const tip = this.amountTip || 0
      // return parseFloat(this.truncDigits(this.amount + fee + tax)).toLocaleString('en-US')
      return (this.amount + fee + tax + tip).toLocaleString('en-US')
    },

    percentTipTxt() {
      return `${this.currentTip?.toFixed(2)}%`
    },

    amountTipTxt() {
      return this.amountFormat(this.amountTip).toLocaleString('en-US')
    },

    serviceCharge() {
      // return parseFloat(this.truncDigits(this.percentFee * this.amount)).toLocaleString('en-US')
      return this.amountFormat(this.percentFee * this.amount).toLocaleString('en-US')
    },

    amountValidate() {
      return !!(this.amount >= this.minTopUp && this.amount <= this.maxAmount)
    },

    maxAmount() {
      return 100000
    },
  },
}
</script>

<style lang="scss" scoped>
  .summary-container {
    padding: 20px;
    background-color: #F5F5F7;
    // border: 1px solid rgba(22, 33, 62, 0.1);
    border-radius: 16px;

    .title-summary{
      margin-bottom: 21px;
    }
  }
  .transfer {
    max-width: 125px;
  }
</style>
